<ng-form
  [formGroup]="pressureCartForm"
  *ngIf="pressureCartOptions"
  id="ng-form_d226fc53"
>
  <div class="options-card" id="div_options-card_f6575a97">
    <div class="options-card-header" id="div_options-card-header_93623ed4">
      FITTINGS & ACCESSORIES
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_425e9bf0"
    >
      <!--DEVICE SETTINGS-->
      <div
        class="checkbox-container-column full-width"
        id="div_checkbox-container-column_64b4312c"
      >
        <div
          class="options-card-body checkbox-body"
          id="div_options-card-body_b9cf60fb"
        >
          <div
            class="options-card-subheader body-item"
            id="div_options-card-subheader_2e26c414"
          >
            Magnetic gauging device settings:
          </div>

          <div
            class="checkbox-container-row vr-body body-item"
            id="div_checkbox-container-row_94eec9fb"
          >
            <ng-container
              *ngFor="let fa of pressureCartOptions['device-settings']"
              id="ng-container_eb4cf1af"
            >
              <div
                class="vertical-radio-button"
                id="div_vertical-radio-button_83a3a7f0"
              >
                <label
                  class="vertical-radio-button-label"
                  [for]="fa.key"
                  id="label_vertical-radio-button-label_e688cf92"
                  >{{ fa.name }}</label
                >

                <p-radioButton
                  class="checkbox-option-row"
                  formControlName="device-settings"
                  name="device-settings"
                  [inputId]="fa.key"
                  [value]="fa"
                  id="p-radioButton_checkbox-option-row_eb97ac66"
                ></p-radioButton>
              </div>
            </ng-container>
          </div>
        </div>

        <div
          class="divider"
          ngClass.lt-lg="lt-lg"
          ngClass.gt-lg="gt-lg"
          id="div_divider_a93f245b"
        ></div>
      </div>

      <!--THERMOWELL-->
      <div
        class="checkbox-container-row"
        id="div_checkbox-container-row_1b47d58a"
      >
        <div
          class="checkbox-container-column full-width"
          id="div_checkbox-container-column_3967cd76"
        >
          <div
            class="checkbox-container-row"
            id="div_checkbox-container-row_419962ff"
          >
            <div
              class="options-card-body radio-horizontal"
              id="div_options-card-body_833739de"
            >
              <div
                class="options-card-subheader body-item"
                id="div_options-card-subheader_b2391cd6"
              >
                Do you need a thermowell?
              </div>

              <div
                class="checkbox-container-row vr-body body-item"
                id="div_checkbox-container-row_3c0d1ed3"
              >
                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_1bba7a45"
                >
                  <label
                    class="vertical-radio-button-label"
                    [innerHTML]="pressureCartOptions['need-thermowell'][0].name"
                    id="label_vertical-radio-button-label_494048e1"
                  ></label>

                  <p-radioButton
                    name="need-thermowell"
                    formControlName="need-thermowell"
                    [value]="pressureCartOptions['need-thermowell'][0]"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_fc677697"
                  >
                  </p-radioButton>
                </div>

                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_8206fc49"
                >
                  <label
                    class="vertical-radio-button-label"
                    id="label_vertical-radio-button-label_950cfd94"
                    >{{ pressureCartOptions['need-thermowell'][1].name }}</label
                  >

                  <p-radioButton
                    name="need-thermowell"
                    formControlName="need-thermowell"
                    [value]="pressureCartOptions['need-thermowell'][1]"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_bcf91968"
                  >
                  </p-radioButton>
                </div>

                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_cc68000d"
                >
                  <label
                    class="vertical-radio-button-label"
                    id="label_vertical-radio-button-label_56a3c997"
                    >{{ pressureCartOptions['need-thermowell'][2].name }}</label
                  >

                  <p-radioButton
                    name="need-thermowell"
                    formControlName="need-thermowell"
                    [value]="pressureCartOptions['need-thermowell'][2]"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_99e16363"
                  >
                  </p-radioButton>
                </div>
              </div>
            </div>
          </div>

          <div
            class="checkbox-container-row"
            id="div_checkbox-container-row_781a467a"
          >
            <div
              class="options-card-body radio-horizontal"
              id="div_options-card-body_a05ed20d"
            >
              <div
                class="options-card-subheader body-item"
                id="div_options-card-subheader_2e9f18ae"
              >
                Do you need a sample line?
              </div>

              <div
                class="checkbox-container-row vr-body body-item"
                id="div_checkbox-container-row_32ff3208"
              >
                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_0bd4fe60"
                >
                  <label
                    class="vertical-radio-button-label spacer"
                    [innerHTML]="
                      pressureCartOptions['need-sample-line'][0].name
                    "
                    id="label_vertical-radio-button-label_51494b35"
                  ></label>

                  <p-radioButton
                    name="need-sample-line"
                    formControlName="need-sample-line"
                    [value]="pressureCartOptions['need-sample-line'][0]"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_6d4ed405"
                  >
                  </p-radioButton>
                </div>

                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_9b687236"
                >
                  <label
                    class="vertical-radio-button-label spacer"
                    id="label_vertical-radio-button-label_dfc0471e"
                    >{{
                      pressureCartOptions['need-sample-line'][1].name
                    }}</label
                  >

                  <p-radioButton
                    name="need-sample-line"
                    formControlName="need-sample-line"
                    [value]="pressureCartOptions['need-sample-line'][1]"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_23900dfe"
                  >
                  </p-radioButton>
                </div>

                <div
                  class="vertical-radio-button"
                  id="div_vertical-radio-button_e857c7a1"
                >
                  <label
                    class="vertical-radio-button-label spacer"
                    id="label_vertical-radio-button-label_b995238c"
                    >{{
                      pressureCartOptions['need-sample-line'][2].name
                    }}</label
                  >

                  <p-radioButton
                    name="need-sample-line"
                    formControlName="need-sample-line"
                    [value]="pressureCartOptions['need-sample-line'][2]"
                    class="checkbox-option-row"
                    id="p-radioButton_checkbox-option-row_9dbdb7c0"
                  >
                  </p-radioButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="options-card" id="div_options-card_c4b22b88">
    <div class="options-card-header" id="div_options-card-header_9473b336">
      GASKET & O-RINGS
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_d5cee0c3"
    >
      <!--FLANGE GASKET-->
      <div class="options-card-body" id="div_options-card-body_f3ebbf8c">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_452be028"
        >
          What type of flange gasket is needed?
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_2b158409"
        >
          <p-multiSelect
            styleClass="multi-select-pressure-cart"
            [inputId]="'flange'"
            #flangeGasketSelect=""
            placeholder="Select flange gasket"
            formControlName="flange-gasket"
            optionLabel="name"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            name="flange-gasket"
            [class.error-label]="
              pressureCartForm.controls['flange-gasket'].invalid &&
              (pressureCartForm.controls['flange-gasket'].dirty ||
                pressureCartForm.controls['flange-gasket'].touched)
            "
            [filterValue]="flangeFilterValue"
            [showClear]="false"
            [filter]="!otherSelected"
            [showHeader]="!otherSelected"
            [options]="pressureCartOptions['flange-gasket']"
            (onPanelHide)="addNewFlange(flangeGasketSelect)"
            (onChange)="checkFlangeValue($event, newFlangeInput)"
            id="p-multiSelect_bcf8582c"
          >
            <p-footer [hidden]="!otherSelected" id="p-footer_d8947c9b">
              <div
                class="multi-select-add-input scale-in-ver-top"
                id="div_multi-select-add-input_267965c0"
              >
                <input
                  [(ngModel)]="newFlangeText"
                  #newFlangeInput=""
                  (keyup.enter)="addNewFlange(flangeGasketSelect)"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Enter text"
                  autofocus=""
                  type="text"
                  id="input_fac31fd2"
                />
              </div>
            </p-footer>

            <ng-template let-fg="" pTemplate="item" id="ng-template_4fd8be19">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_34af0b9e"
              >
                <div id="div_978efb88">{{ fg.name }}</div>
              </div>
            </ng-template>

            <ng-template pTemplate="empty" id="ng-template_ea036a1b">
              <div fxLayout="column" id="div_222f361f">
                <div
                  fxLayout="column"
                  [hidden]="otherSelected"
                  id="div_764ffd68"
                >
                  <div [hidden]="otherSelected" id="div_fd0daafe">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="showAddFlange(newFlangeInput)"
                      [binary]="true"
                      [(ngModel)]="otherSelected"
                      id="p-checkbox_22a2da5a"
                    ></p-checkbox>
                  </div>
                </div>

                <div
                  style="margin-bottom: -22px"
                  [hidden]="!otherSelected"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  id="div_6682ac1e"
                >
                  <div id="div_e75bb8f2">
                    <p-checkbox
                      [ngModelOptions]="{ standalone: true }"
                      label="Other"
                      (onChange)="focusFilterInput(flangeGasketSelect)"
                      [binary]="true"
                      [(ngModel)]="otherSelected"
                      id="p-checkbox_12026be4"
                    ></p-checkbox>
                  </div>

                  <button
                    (click)="hideAddFlange(flangeGasketSelect)"
                    pButton=""
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                    id="button_p-button-rounded_45f9c034"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              pressureCartForm.controls['flange-gasket'].invalid &&
              (pressureCartForm.controls['flange-gasket'].dirty ||
                pressureCartForm.controls['flange-gasket'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_74ef9b78"
          >
            <div
              *ngIf="
                pressureCartForm.controls['flange-gasket'].errors?.['required']
              "
              id="div_f70a27a4"
            >
              Required field
            </div>
          </div>
        </div>
      </div>

      <!--O-RING-->
      <div class="options-card-body" id="div_options-card-body_74933a2b">
        <div
          class="options-card-subheader body-item"
          id="div_options-card-subheader_4463de5e"
        >
          What o-ring is required?
        </div>

        <div
          class="multi-select-pressure-cart body-item"
          id="div_multi-select-pressure-cart_9a98f734"
        >
          <p-multiSelect
            placeholder="Select o-ring type"
            [inputId]="'oring'"
            styleClass="multi-select-pressure-cart"
            #oringSelect=""
            optionLabel="name"
            formControlName="o-ring-required"
            [showToggleAll]="false"
            filterPlaceHolder="Search..."
            [class.error-label]="
              pressureCartForm.controls['o-ring-required'].invalid &&
              (pressureCartForm.controls['o-ring-required'].dirty ||
                pressureCartForm.controls['o-ring-required'].touched)
            "
            [filter]="!otherSelectedoRing"
            [showHeader]="!otherSelectedoRing"
            (onPanelHide)="addNewOring(oringSelect)"
            (onChange)="checkOringValue($event, newOringInput)"
            [filterValue]="oringFilterValue"
            [showClear]="false"
            [options]="pressureCartOptions['o-ring-required']"
            id="p-multiSelect_6c00cbe2"
          >
            <p-footer [hidden]="!otherSelectedoRing" id="p-footer_3b001088">
              <div
                class="multi-select-add-input"
                id="div_multi-select-add-input_65f6449b"
              >
                <input
                  [(ngModel)]="newOringText"
                  [ngModelOptions]="{ standalone: true }"
                  #newOringInput=""
                  (keyup.enter)="addNewOring(oringSelect)"
                  placeholder="Enter text"
                  autofocus=""
                  type="text"
                  id="input_d706545f"
                />
              </div>
            </p-footer>

            <ng-template
              let-oring=""
              pTemplate="item"
              id="ng-template_e39189e1"
            >
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_d6b73140"
              >
                <div id="div_7b1aedc2">{{ oring.name }}</div>
              </div>
            </ng-template>

            <ng-template pTemplate="empty" id="ng-template_3b4180c0">
              <div fxLayout="column" id="div_2a76960d">
                <div
                  fxLayout="column"
                  [hidden]="otherSelectedoRing"
                  id="div_49139d18"
                >
                  <div [hidden]="otherSelectedoRing" id="div_12eb1e4d">
                    <p-checkbox
                      label="Other"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="showAddOring(newOringInput)"
                      [binary]="true"
                      [(ngModel)]="otherSelectedoRing"
                      id="p-checkbox_80bb1f36"
                    ></p-checkbox>
                  </div>
                </div>

                <div
                  style="margin-bottom: -22px"
                  [hidden]="!otherSelectedoRing"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  id="div_edd1047b"
                >
                  <div id="div_1dee1e6d">
                    <p-checkbox
                      [ngModelOptions]="{ standalone: true }"
                      label="Other"
                      (onChange)="focusFilterInput(oringSelect)"
                      [binary]="true"
                      [(ngModel)]="otherSelectedoRing"
                      id="p-checkbox_0447c6d6"
                    ></p-checkbox>
                  </div>

                  <button
                    (click)="hideAddOring(oringSelect)"
                    pButton=""
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                    id="button_p-button-rounded_adec8855"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              pressureCartForm.controls['o-ring-required'].invalid &&
              (pressureCartForm.controls['o-ring-required'].dirty ||
                pressureCartForm.controls['o-ring-required'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_d1e10722"
          >
            <div
              *ngIf="
                pressureCartForm.controls['o-ring-required'].errors?.[
                  'required'
                ]
              "
              id="div_fd8da76b"
            >
              Required field
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--INTERIOR PREP-->
  <div class="options-card" id="div_options-card_0b241f2f">
    <div class="options-card-header" id="div_options-card-header_0f05a1b9">
      <div id="div_217d2d11">
        INTERIOR PREP<i
          (click)="displayInteriorPrepHelp = true"
          class="pi pi-info-circle prep-info-button"
          id="i_pi_89aa9889"
        ></i>
      </div>

      <div
        *ngIf="displayInteriorPrepHelp"
        class="dialog-tooltip-container"
        id="div_dialog-tooltip-container_61589401"
      >
        <div class="dialog-tooltip" id="div_dialog-tooltip_94d37f00">
          <div class="dialog-title" id="div_dialog-title_d63dc60a">
            Interior Prep
          </div>

          <div style="width: 386px; height: 131px" id="div_bcfa8ac3">
            Standards are defined by The Association for Materials <br />
            Protection and Performance. For details, visit <br />
            <a
              aria-label="about"
              title="about"
              target="_blank"
              href="https://ampp.org/about"
              id="a_7b70d054"
              >ampp.org/about</a
            >
            or see SSPC-VIS 1 Standards for Dry <br />
            Abrasive Blast Cleaning.
          </div>
        </div>
      </div>
    </div>

    <div
      class="options-card-container"
      id="div_options-card-container_34940084"
    >
      <div
        class="checkbox-container-column"
        fxFlex.lt-lg="56"
        fxFlex.gt-lg="26"
        fxFlex.lg="51"
        id="div_checkbox-container-column_7aa7d378"
      >
        <ng-container
          *ngFor="let fa of pressureCartOptions['interior-prep']"
          id="ng-container_566285c9"
        >
          <p-radioButton
            class="checkbox-option"
            formControlName="interior-prep"
            name="interior-prep"
            [inputId]="fa.key"
            (ngModelChange)="
              checkRadioOtherValue($event, 'InteriorPrep', newInteriorInput)
            "
            [value]="fa"
            [label]="fa.name"
            id="p-radioButton_checkbox-option_a11c5265"
          ></p-radioButton>
        </ng-container>

        <div
          [hidden]="!addinginteriorPrep"
          class="select-add-input scale-in-ver-top"
          id="div_select-add-input_5f6d7bdd"
        >
          <input
            #newInteriorInput=""
            [ngModelOptions]="{ standalone: true }"
            (change)="addingOtherValue('InteriorPrep')"
            [(ngModel)]="newinteriorPrepText"
            autofocus=""
            placeholder="Enter text"
            id="input_b7a302a6"
          />
        </div>
      </div>
    </div>
  </div>

  <!--PURGE & PAD-->
  <div class="options-card" id="div_options-card_aa7e6d1a">
    <div class="options-card-header" id="div_options-card-header_8ba7f786">
      PURGE & PAD
    </div>

    <div class="options-card-body" id="div_options-card-body_798630db">
      <div
        class="checkbox-container-column body-item"
        id="div_checkbox-container-column_c3c64fe1"
      >
        <div
          class="options-card-subheader"
          id="div_options-card-subheader_b6ac824c"
        >
          Oxygen content
        </div>

        <ng-container
          *ngFor="let ox of pressureCartOptions['oxygen-content']"
          id="ng-container_1944a1de"
        >
          <p-radioButton
            class="checkbox-option"
            formControlName="oxygen-content"
            name="oxygen-content"
            [inputId]="ox.key"
            [value]="ox"
            (ngModelChange)="
              checkRadioOtherValue(
                $event,
                'OxygenContent',
                newOxygenContentInput
              )
            "
            [label]="ox.name"
            id="p-radioButton_checkbox-option_c31f7819"
          ></p-radioButton>
        </ng-container>

        <div
          [hidden]="!addingOxygenContent"
          class="select-add-input scale-in-ver-top"
          id="div_select-add-input_be73b382"
        >
          <input
            #newOxygenContentInput=""
            [ngModelOptions]="{ standalone: true }"
            (change)="addingOtherValue('OxygenContent')"
            [(ngModel)]="newOxygenContentText"
            autofocus=""
            placeholder="Enter text"
            id="input_f88454fb"
          />
        </div>
      </div>

      <div
        class="checkbox-container-column body-item"
        id="div_checkbox-container-column_c408f435"
      >
        <div
          class="options-card-subheader"
          ngClass.lt-lg="lt-lg"
          id="div_options-card-subheader_1b9e42f6"
        >
          Nitrogen PSI
        </div>

        <ng-container
          *ngFor="let fa of pressureCartOptions['nitrogen-psi']"
          id="ng-container_9da209a2"
        >
          <p-radioButton
            class="checkbox-option"
            name="nitrogen-psi"
            formControlName="nitrogen-psi"
            [inputId]="fa.key"
            (ngModelChange)="
              checkRadioOtherValue($event, 'NitrogenPSI', newNitrogenPSIInput)
            "
            [value]="fa"
            [label]="fa.name"
            id="p-radioButton_checkbox-option_059a9f32"
          ></p-radioButton>
        </ng-container>

        <div
          [hidden]="!addingNitrogenPSI"
          class="select-add-input scale-in-ver-top"
          id="div_select-add-input_6273a055"
        >
          <input
            #newNitrogenPSIInput=""
            (change)="addingOtherValue('NitrogenPSI')"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="newNitrogenPSIText"
            autofocus=""
            placeholder="Enter text"
            id="input_c85a23bd"
          />
        </div>
      </div>
    </div>
  </div>

  <input
    formControlName="selected"
    type="hidden"
    [value]="true"
    id="input_63f99816"
  />

  <div class="button-container" id="div_button-container_191edccf">
    <button
      icon="pi pi-arrow-left"
      (click)="back()"
      class="back-button"
      pButton=""
      label="Previous"
      id="button_back-button_03e44981"
    ></button>

    <button
      class="quiz-button"
      styleClass="p-button-next"
      [disabled]="!pressureCartForm.valid"
      (click)="next()"
      icon="pi pi-arrow-right"
      pButton=""
      label="Next"
      id="button_quiz-button_1f8fdfaa"
    ></button>
  </div>
</ng-form>

<p-progressSpinner
  *ngIf="!pressureCartOptions"
  fxLayout="column"
  fxFlexAlign="center center"
  id="p-progressSpinner_baf4a784"
></p-progressSpinner>

<div
  class="info-help-dialog-click-overlay"
  (click)="displayInteriorPrepHelp = false"
  [hidden]="!displayInteriorPrepHelp"
  id="div_info-help-dialog-click-overlay_28551dff"
></div>
